import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export type AlertaTono = "peligro" | "alerta";

const TONOS: Record<AlertaTono, string> = {
  peligro: "bg-peligro-suave text-peligro",
  alerta: "bg-alerta-suave text-alerta",
};

export type AlertaProps = { texto: string | null | undefined; tono?: AlertaTono; accion?: ReactNode };

/** Mensaje en línea con `role="alert"` (errores, avisos). Sin texto no renderiza nada. `accion`: un link al lado del texto. */
export function Alerta({ texto, tono = "peligro", accion }: AlertaProps) {
  if (!texto) return null;
  return (
    <p role="alert" className={cn("rounded-control px-3 py-2 text-chico", TONOS[tono])}>
      {texto}
      {accion && <> {accion}</>}
    </p>
  );
}
